import trainRoutes from './routes'

/* @ngInject */
const run = (
  $transitions,
  storageHandler,
  $$train,
  $$wagon,
  toaster
) => {
  $transitions.onSuccess({
    entering: trainRoutes.home.path,
  }, (trans) => {
    if (storageHandler.get('consult.train.homeTrain')) {
      $$train.data.myTrain = storageHandler.get('consult.train.homeTrain')
    } else {
      $$train.data.myTrain = $$train.new.search()
    }

    if (storageHandler.get('consult.train.homeTrains')) {
      $$train.data.myTrains = storageHandler.get('consult.train.homeTrains')
    } else {
      $$train.data.myTrains.splice(0, $$train.data.myTrains.length)
    }
  })

  $transitions.onBefore({
    from: trainRoutes.home.path,
  }, (trans) => {
    if (!trans.to().redirectTo) {
      storageHandler.save('consult.train.homeTrain', $$train.data.myTrain)
      storageHandler.save('consult.train.homeTrains', $$train.data.myTrains)
      $$train.data.myTrain = null
      $$train.data.myTrains.splice(0, $$train.data.myTrains.length)
    }
  })

  $transitions.onSuccess({
    entering: trainRoutes.details.path,
  }, async (trans) => {
    const trainId = $$train.local.getCurrentId()
    try {
      if (!$$train.data.myTrain || $$train.data.myTrain.id !== trainId) {
        $$train.data.myTrain = await $$train.request.getById(trainId)
      }
      $$wagon.data.myWagons = await $$train.request.getWagons(trainId)
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    exiting: trainRoutes.details.path,
  }, async (trans) => {
    $$train.data.myTrain = null
    $$wagon.data.myWagons = null
  })

  $transitions.onSuccess({
    entering: trainRoutes.edit.path,
  }, async (trans) => {
    const trainId = $$train.local.getCurrentId()

    try {
      const train = await $$train.request.getById(trainId)
      $$train.data.myTrain = $$train.format.user(train)
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onSuccess({
    exiting: trainRoutes.edit.path,
  }, async (trans) => {

  })
}

export default run



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/train/train.run.js